import {AqsQueuedAppointmentCommunicationType} from "@/open_api/generated";

export import QueuedAppointmentType = AqsQueuedAppointmentCommunicationType;
